import React from 'react'
import { inject, observer } from 'mobx-react'

import CompaniesTableActions from './CompaniesTableActions'
import TagList from '../../../generic/TagList'
import Table from '../../../generic/Table'
import Loader from '../../../generic/Loader'

const CompaniesTable = inject('configCompaniesStore', 'companyProductStore')(observer(props => {
  const { configCompaniesStore, companyProductStore } = props
  const { companies, isFetching } = configCompaniesStore.state
  const tableHeaders = ['Nome', 'CNPJ', 'Produtos', 'Filiais', '']
  const tableRows = companies.map(data => {
    const productTags = data.products.names.map(product => {
      const isClickable = companyProductStore.state[product] ? true : false
      return {
        text: product,
        onClick: () => {
          if (isClickable) {
            companyProductStore.setProductFormData(product, data.products[product].data, data.id)
            companyProductStore.openProductModal(product)
          }
        },
        isClickable: isClickable
      }
    })
    const branchTags = data.branches.map(data => {
      return {
        text: data.name
      }
    })
    return [
      data.name,
      data.cnpj,
      <TagList tags={productTags} />,
      <TagList tags={branchTags} />,
      <CompaniesTableActions company={data} />
    ]
  }).sort((current, next) => current[0].localeCompare(next[0]))
  return (
    <Loader isLoading={isFetching}>
      <Table rows={tableRows} headers={tableHeaders} />
    </Loader>
  )
}))

export default CompaniesTable



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/CompaniesTable.js